import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//prime react
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { confirmDialog } from "primereact/confirmdialog";
//components
import TextareaInput from "../../../components/input/TextareaInput";
// utils
import { formatCurrency } from "../../../utils/formatCurrency";
import { postReceiptReversal } from "../../../services/Financial/postReceiptReversal";
import { formatDate } from "../../../utils/formatDate";

export const AccountReceiptReversal = ({ rowsSelected, closeModal }) => {
  const form = useForm();
  const errors = form.formState.errors;

  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "id", header: `ID` },
    {
      field: "value",
      header: `Valor`,
      body: (rowData) => formatCurrency(rowData.value),
    },
    {
      field: "due_date",
      header: "Data de vencimento",
      body: (rowData) => formatDate(rowData.due_date),

    },
    {
      field: "payment_value",
      header: "Valor recebido",
      body: (rowData) => formatCurrency(rowData.payment_value || 0),
    },
    {
      field: "payment_method.name",
      header: "Forma de pagamento",
    },
    {
      field: "payment_date",
      header: "Data de pagamento",
      body: (rowData) => formatDate(rowData.payment_date),
    },
  ];

  async function onSubmit(data) {
    confirmDialog({
      message: "Deseja realizar o estorno de recebimento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => sendRequest(data),
    });
  }

  async function sendRequest(data) {
    if (!rowsSelected.length) {
      toast.warning("Selecione ao menos uma parcela!");
      closeModal();
      return;
    }

    //    console.log(rowsSelected);

    const validate = rowsSelected.map((row) => {
      return row.status === 0;
    });

    if (validate[0] === true) {
      toast.warning(
        "Não é possível realizar o estorno de parcela(s) com o status em Aberto!"
      );

      return;
    }

    setLoading(true);

    const notification = toast.loading("Realizando o estorno de recebimento..");

    const arrByID = rowsSelected.map((row) => {
      return row.id; // return just id
    });

    data.installments_ids = arrByID; // add id in obj

    try {
      const response = await postReceiptReversal(data);

      if (response.success) {
        toast.update(notification, {
          render: response.success,
          type: "success",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });

        form.reset();
      }
    } catch (e) {
      toast.update(notification, {
        render: "Oops! Algo deu errado!",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } finally {
      closeModal();
      setLoading(false);
    }
  }

  return (
    <>
      <h5 className="pb-3">Preencha o motivo do estorno do recebimento</h5>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="mb-2">
          <div className="row">
            <TextareaInput
              name="obs"
              isRequired={true}
              label="Motivo do estorno"
              errors={errors}
              control={form.control}
            />
          </div>
        </div>
        <div>
          <h3>Parcelas Selecionadas</h3>
        </div>
        <div className="px-0 py-3">
          <DataTable
            rows={25}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="multiple"
            rowsPerPageOptions={[5, 25, 100]}
            value={rowsSelected}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
              />
            ))}
          </DataTable>
        </div>
        <div className="text-center mt-3">
          <Button
            rounded
            loading={loading}
            type="submit"
            label="Confirmar Estorno"
            icon="fa-solid fa-check"
            className="p-inputtext-sm m-auto"
          />
        </div>
      </form>
    </>
  );
};
